module.exports = __webpack_public_path__ + "media/sneakers.e7a6c959.mp4";